import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#1685C7',
        secondary: '#424242',
        accent: '#1FAD1F',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FF931E'
      }
    }
  }
})
